module.exports = __webpack_public_path__ + "05_short_black.6727a605.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/05_short_black.png
// module id = rfNW
// module chunks = 0